import React from 'react';

export function Logo({ compact = false, light = false, showImage = true }) {
  return (
    <div className="flex items-center gap-2.5">
      {showImage && (
        <img src="/nuxfleet-logo.png" alt="NuxFleet" className="h-10 w-10 rounded-full object-contain" />
      )}
      {!compact && (
        <div className="leading-tight">
          <div className={`font-logo text-lg font-extrabold tracking-tight ${light ? 'text-white' : 'text-foreground'}`}>
            Nux<span className="text-[hsl(var(--primary))]">Fleet</span>
          </div>
          <div className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? 'text-white/70' : 'text-muted-foreground'}`}>
            Smart Fleet Ops
          </div>
        </div>
      )}
    </div>
  );
}
